import { render } from "./OldSchoolFooter.vue?vue&type=template&id=1e9f90a1&scoped=true"
import script from "./OldSchoolFooter.vue?vue&type=script&lang=js"
export * from "./OldSchoolFooter.vue?vue&type=script&lang=js"

import "./OldSchoolFooter.vue?vue&type=style&index=0&id=1e9f90a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9f90a1"]])

export default __exports__